import {
  createColumnHelper, flexRender, getCoreRowModel,
  getSortedRowModel, SortingState, useReactTable,
} from "@tanstack/react-table";
import DivLoader from "components/divloader/DivLoader";
import React from "react";
import { PaymentMethodRowObj } from "..";
import CreatePaymentMethoddModal from "./CreatePaymentMethod";
import Searchbox from "components/fields/Searchbox";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { MdCheckCircle, MdCancel } from "react-icons/md";

// ── Gateway image imports ──
import Pix from "../../../../assets/img/payment-clients/pix.png";
import pixLotus from "../../../../assets/img/payment-clients/pix.png";
import Stripe from "../../../../assets/img/payment-clients/stripe.png";
import Blumon from "../../../../assets/img/payment-clients/blumon.png";
import Sipe from "../../../../assets/img/payment-clients/sipe.png";
import Memphis from "../../../../assets/img/payment-clients/memphis.png";
import Neonpay from "../../../../assets/img/payment-clients/neonpay.png";
import repyd from "../../../../assets/img/payment-clients/rapyd.png";
import mit from "../../../../assets/img/payment-clients/mit.png";
import banwire from "../../../../assets/img/payment-clients/banwire.jpg";
import valitor from "../../../../assets/img/payment-clients/valitor.png";
import bambora from "../../../../assets/img/payment-clients/bambora.png";
import Scipiopay from "../../../../assets/img/payment-clients/Scipiopay.png";
import Aurea_via from "../../../../assets/img/payment-clients/Aurea_via.png";
import Betapay from "../../../../assets/img/payment-clients/Betapay.png";
import Kasha from "../../../../assets/img/payment-clients/Kasha.jpg";
import Platy from "../../../../assets/img/payment-clients/Platy.png";
import reSet from "../../../../assets/img/payment-clients/reset.png";
import Supefina from "../../../../assets/img/payment-clients/supefina.svg";
import Linx from "../../../../assets/img/payment-clients/linx_logo.png";
import Masterpay from "../../../../assets/img/payment-clients/master_Pay.png";
import Bm2pay from "../../../../assets/img/payment-clients/bm2pay.svg";
import Threexpay from "../../../../assets/img/payment-clients/3XPAY.png";
import Digitarium from "../../../../assets/img/payment-clients/digitarium.png";
import Moneto from "../../../../assets/img/payment-clients/moneto.png";
import Tangoindia from "../../../../assets/img/payment-clients/tangoindia.png";
import G2pay from "../../../../assets/img/payment-clients/g2pay.png";
import AlphaPays from "../../../../assets/img/payment-clients/alphapays.svg";
import Clickopay from "../../../../assets/img/payment-clients/clickopay.svg";
import CFGPayments from "../../../../assets/img/payment-clients/cfg.png";
import Ragapay from "../../../../assets/img/payment-clients/ragapay.png";
import Capa from "../../../../assets/img/payment-clients/capa.svg";
import Orionx from "../../../../assets/img/payment-clients/orionx.svg";
import Mauricio from "../../../../assets/img/payment-clients/placeholder.png";
import Blox from "../../../../assets/img/payment-clients/blox.svg";
import Terracall from "../../../../assets/img/payment-clients/Terracall.png";
import MyXspend from "../../../../assets/img/payment-clients/myxspend.svg";
import Bennupay from "../../../../assets/img/payment-clients/bennupay.png";
import Xorapay from "../../../../assets/img/payment-clients/Xorapay.png";
import TestGateway from "../../../../assets/img/payment-clients/testgateway.png";
import Murkon from "../../../../assets/img/payment-clients/Murkon.png";
import Changelly from "../../../../assets/img/payment-clients/Changelly.png";
import Transvoucher from "../../../../assets/img/payment-clients/Transvoucher.png";
import DNSPay from "../../../../assets/img/payment-clients/dnspay.png";
import Gate2Way from "../../../../assets/img/payment-clients/Gate2Way.png";
import PayoutsTech from "../../../../assets/img/payment-clients/PayoutsTech.png";

const columnHelper = createColumnHelper<PaymentMethodRowObj>();

/* ── Resolve gateway logo ── */
const resolveLogoSrc = (name: string): string => {
  const n = name?.toLowerCase?.() ?? "";
  const exact: Record<string, string> = {
    "pix": Pix, "pix-lotus": pixLotus, "stripe": Stripe, "blumon": Blumon,
    "sipe": Sipe, "re-set": reSet, "memphis": Memphis, "raypd": repyd,
    "banwire": banwire, "valitor": valitor, "bambora": bambora, "mit": mit,
    "digitarium": Digitarium, "tangoindia": Tangoindia, "g2pay": G2pay,
    "alphapays": AlphaPays, "clickopay": Clickopay, "cfgpayments": CFGPayments,
    "ragapay": Ragapay, "capa": Capa, "orionx": Orionx, "mauricio": Mauricio,
    "blox": Blox, "terracall": Terracall, "myxspend": MyXspend,
    "bennupay": Bennupay, "xorapay": Xorapay, "murkon": Murkon,
    "changelly fiat": Changelly, "changelly crypto": Changelly,
    "transvoucher": Transvoucher, "dnspay": DNSPay, "gate2way": Gate2Way,
    "payouts tech": PayoutsTech, "testgateway": TestGateway, "moneto": Moneto,
    "scipiopay": Scipiopay, "aurea via": Aurea_via, "betapay": Betapay,
    "kasha": Kasha, "supefina": Supefina, "platy": Platy, "platy 2ds": Platy,
    "platy 3ds": Platy, "linx": Linx, "masterpay": Masterpay,
    "neonpay": Neonpay, "bm2pay": Bm2pay, "3xpay": Threexpay,
  };
  return exact[n] ?? "";
};

/* ── Boolean cell ── */
const BoolCell = ({ value }: { value: boolean }) => (
  <div className="pm-bool-cell">
    {value
      ? <span className="pm-bool pm-bool--yes"><MdCheckCircle size={15} />Yes</span>
      : <span className="pm-bool pm-bool--no"><MdCancel size={15} />No</span>}
  </div>
);

function PaymentMethodTable(props: {
  tableData: any; fetchUsers: () => void; isLoading: boolean;
  page: number; setPage: any; totalpage: number; totalItems: number;
  currentPage: number; pageSize: number; setPageSize: any; roleData: any;
  timeZone: any; allCardType: any; onValueChange: (value: string) => void;
}) {
  const {
    tableData, fetchUsers, roleData, timeZone, allCardType, onValueChange,
  } = props;

  const showPaymentName = roleData[0]?.payment_method?.value?.show_payment_method_name;
  const canEdit = roleData?.[0]?.payment_method?.value?.edit_payment_method;

  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [data, setData] = React.useState(() => [...(tableData ?? [])]);
  React.useEffect(() => { setData(tableData ?? []); }, [tableData]);

  /* ── Logo column ── */
  const logoCol = columnHelper.accessor("logo", {
    id: "logo",
    header: () => <span className="pm-th">Logo</span>,
    cell: (info: any) => {
      const src = resolveLogoSrc(info.getValue());
      return (
        <div className="pm-logo-cell">
          {src
            ? <img src={src} alt={info.getValue()} className="pm-logo-img" />
            : <div className="pm-logo-placeholder">{info.getValue()?.charAt(0)?.toUpperCase() || "?"}</div>}
        </div>
      );
    },
    enableSorting: false,
  });

  /* ── Name / ID column (role-dependent) ── */
  const nameOrIdCol = showPaymentName
    ? columnHelper.accessor("name", {
        id: "name",
        header: () => <span className="pm-th">Name</span>,
        cell: (info: any) => <span className="pm-cell-text">{info.getValue()}</span>,
      })
    : columnHelper.accessor("id", {
        id: "id",
        header: () => <span className="pm-th">Hash ID</span>,
        cell: (info: any) => <span className="pm-cell-muted">{info?.row?.original?.id}</span>,
      });

  /* ── Type column ── */
  const typeCol = columnHelper.accessor("type", {
    id: "type",
    header: () => <span className="pm-th">Type</span>,
    cell: (info: any) => <span className="pm-type-tag">{info.getValue()}</span>,
  });

  /* ── Status column ── */
  const statusCol = columnHelper.accessor("is_active", {
    id: "is_active",
    header: () => <span className="pm-th">Status</span>,
    cell: (info: any) => (
      info.getValue()
        ? <span className="pm-status pm-status--active">Active</span>
        : <span className="pm-status pm-status--inactive">Inactive</span>
    ),
  });

  /* ── Bool columns ── */
  const boolCol = (accessor: any, label: string) =>
    columnHelper.accessor(accessor, {
      id: accessor,
      header: () => <span className="pm-th pm-th--center">{label}</span>,
      cell: (info: any) => <BoolCell value={info.getValue()} />,
    });

  /* ── Action column ── */
  const actionCol = columnHelper.accessor("name", {
    id: "action",
    header: () => <span className="pm-th">Action</span>,
    cell: (info: any) => (
      <CreatePaymentMethoddModal
        fetchUsers={fetchUsers}
        id={info.getValue()}
        data={info.row?.original}
        roleData={roleData}
        timeZone={timeZone}
        allCardType={allCardType}
      />
    ),
    enableSorting: false,
  });

  const sharedCols = [
    logoCol, nameOrIdCol, typeCol,
    boolCol("payments", "Payment"),
    boolCol("refund", "Refund"),
    boolCol("apm", "APM"),
    boolCol("authorization", "Authorization"),
    boolCol("subscription", "Subscription"),
    boolCol("token", "Token"),
    boolCol("payout", "Payout"),
    boolCol("payin", "Payin"),
    boolCol("crypto_payin", "Crypto Payin"),
    boolCol("crypto_payout", "Crypto Payout"),
    statusCol,
  ];

  const columns = canEdit ? [...sharedCols, actionCol] : sharedCols;

  const table = useReactTable({
    data, columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <div className="pm-card">
      {/* Header */}
      <div className="pm-header">
        <div className="pm-header-left">
          <div className="pm-header-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
          </div>
          <div>
            <h3 className="pm-title">All Gateways</h3>
            <p className="pm-subtitle">
              {data.length > 0 ? `${data.length} gateway${data.length !== 1 ? "s" : ""} configured` : "No gateways found"}
            </p>
          </div>
        </div>
        <div className="pm-header-right">
          <Searchbox onSearch={(e) => { onValueChange(e); }} />
        </div>
      </div>

      {/* Table */}
      <div className="pm-table-wrap">
        {props.isLoading ? (
          <div className="pm-loading">
            <div className="pm-spinner" />
            <p className="pm-loading-txt">Loading gateways…</p>
          </div>
        ) : (
          <table className="pm-table">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th key={h.id} colSpan={h.colSpan}
                      onClick={h.column.getCanSort() ? h.column.getToggleSortingHandler() : undefined}
                      className={`pm-thead-th${h.column.getCanSort() ? " pm-thead-th--sort" : ""}`}
                    >
                      <div className="pm-th-inner">
                        {flexRender(h.column.columnDef.header, h.getContext())}
                        {h.column.getCanSort() && (
                          <span className="pm-sort-icon">
                            {h.column.getIsSorted() === "asc" ? <BsArrowUp size={11} /> :
                             h.column.getIsSorted() === "desc" ? <BsArrowDown size={11} /> :
                             <RiArrowUpDownFill size={11} />}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row, ri) => (
                  <tr key={row.id} className={`pm-tbody-tr${ri % 2 !== 0 ? " pm-tbody-tr--alt" : ""}`}>
                    {row.getVisibleCells().map((cell, ci) => (
                      <td key={ci} className="pm-tbody-td">
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr><td colSpan={16}>
                  <div className="pm-empty">
                    <div className="pm-empty-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="1" y="4" width="22" height="16" rx="2"/>
                        <line x1="1" y1="10" x2="23" y2="10"/>
                      </svg>
                    </div>
                    <p className="pm-empty-title">No gateways found</p>
                    <p className="pm-empty-sub">Try adjusting your search or add a new gateway</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* Card */
        .pm-card { font-family:'Plus Jakarta Sans',sans-serif; background:#fff; border:1px solid #e2e8f0; border-radius:18px; overflow:hidden; box-shadow:0 2px 8px rgba(15,23,42,0.06); }

        /* Header */
        .pm-header { padding:15px 20px 12px; border-bottom:1px solid #f1f5f9; display:flex; align-items:center; justify-content:space-between; gap:14px; flex-wrap:wrap; }
        .pm-header-left { display:flex; align-items:center; gap:10px; }
        .pm-header-icon {
            width: 36px;
            height: 36px;
            border-radius: 10px;
            background: linear-gradient(135deg, #eff6ff, #dbeafe);
            border: 1.5px solid #bfdbfe;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2563eb;
            flex-shrink: 0;
        }
        .pm-title { 
            font-size: 14px;
            font-weight: 700;
            color: #0f172a;
            letter-spacing: -.2px;
            margin-bottom: 1px;
            line-height: 20px;
        }
        .pm-subtitle { 
            font-size: 11.5px;
            color: #94a3b8;
            font-weight: 500;
        }
        .pm-header-right { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }

        /* Table */
        .pm-table-wrap { overflow-x:auto; }
        .pm-table-wrap::-webkit-scrollbar { height:4px; }
        .pm-table-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
        .pm-table { width:100%; border-collapse:collapse; }

        .pm-thead-th { padding:11px 14px 9px; background:#f8fafc; border-bottom:1.5px solid #e2e8f0; text-align:left; white-space:nowrap; user-select:none; }
        .pm-thead-th--sort { cursor:pointer; }
        .pm-thead-th--sort:hover { background:#f1f5f9; }
        .pm-th-inner { display:flex; align-items:center; gap:5px; }
        .pm-th { font-size:11px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:0.5px; }
        .pm-th--center { display:flex; justify-content:center; }
        .pm-sort-icon { color:#94a3b8; display:flex; align-items:center; }

        .pm-tbody-tr { transition:background .12s; }
        .pm-tbody-tr:hover { background:#f8fafc; }
        .pm-tbody-tr--alt { background:#fafbfc; }
        .pm-tbody-td { padding:11px 14px; border-bottom:1px solid #f1f5f9; vertical-align:middle; }

        /* Logo cell */
        .pm-logo-cell { display:flex; align-items:center; justify-content:flex-start; }
        .pm-logo-img { height:auto; width:44px; object-fit:contain; }
        .pm-logo-placeholder { width:44px; height:32px; border-radius:8px; background:linear-gradient(135deg,#f1f5f9,#e2e8f0); border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; font-size:13px; font-weight:800; color:#64748b; }

        /* Text cells */
        .pm-cell-text { font-size:13px; font-weight:600; color:#0f172a; white-space:nowrap; }
        .pm-cell-muted { font-size:12px; font-weight:500; color:#64748b; white-space:nowrap; font-family:'JetBrains Mono','Courier New',monospace; }

        /* Type tag */
        .pm-type-tag { display:inline-block; padding:3px 10px; border-radius:7px; font-size:11px; font-weight:700; background:#f0f9ff; border:1.5px solid #bae6fd; color:#0284c7; text-transform:uppercase; white-space:nowrap; letter-spacing:0.3px; }

        /* Bool cell */
        .pm-bool-cell { display:flex; justify-content:center; }
        .pm-bool { display:inline-flex; align-items:center; gap:4px; font-size:11px; font-weight:700; padding:3px 8px; border-radius:7px; white-space:nowrap; }
        .pm-bool--yes { background:#f0fdf4; border:1.5px solid #bbf7d0; color:#15803d; }
        .pm-bool--no  { background:#fff1f2; border:1.5px solid #fecdd3; color:#be123c; }

        /* Status badge */
        .pm-status { display:inline-flex; align-items:center; gap:5px; padding:4px 10px; border-radius:8px; font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:0.3px; white-space:nowrap; }
        .pm-status--active   { background:linear-gradient(135deg,#f0fdf4,#dcfce7); border:1.5px solid #bbf7d0; color:#15803d; }
        .pm-status--inactive { background:linear-gradient(135deg,#fff1f2,#ffe4e6); border:1.5px solid #fecdd3; color:#be123c; }

        /* Loading / empty */
        .pm-loading { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:56px; gap:12px; }
        .pm-spinner { width:28px; height:28px; border:3px solid #e2e8f0; border-top-color:#2563eb; border-radius:50%; animation:pmSpin .7s linear infinite; }
        @keyframes pmSpin { to{transform:rotate(360deg)} }
        .pm-loading-txt { font-size:13px; color:#94a3b8; font-weight:500; }
        .pm-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:56px 24px; gap:10px; }
        .pm-empty-icon { width:52px; height:52px; border-radius:13px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
        .pm-empty-title { font-size:14px; font-weight:700; color:#64748b; }
        .pm-empty-sub { font-size:12.5px; color:#94a3b8; font-weight:500; text-align:center; }

        @media (max-width:700px) { .pm-header { flex-direction:column; align-items:flex-start; } .pm-header-right { width:100%; } }
      `}</style>
    </div>
  );
}

export default PaymentMethodTable;